import "./App.css";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { ManufacturerPage } from "./pages/ManufacturerPage";
import { DatePage } from "./pages/DatePage";
import { SkuPage } from "./pages/SkuPage";
import { HomePage } from "./pages/HomePage";
import { MyTrackedStocksPage } from "./pages/MyTrackedStocksPage"; 
import Navbar from "./navbar/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import { ThemeProvider } from "@mui/material";
import SubscriptionPage from "./pages/SubscriptionPage";
import CreditsPage from "./pages/CreditsPage"; // Import new credits page
import { AuthProvider } from "./context/AuthContext";
import theme from "./theme";
import LandingPage from "./pages/LandingPage";
import OAuth2RedirectHandler from "./OAuth2RedirectHandler";
import ProfilePage from "./pages/ProfilePage";

function App() {
    return (
        <AuthProvider>
            <ThemeProvider theme={theme}>
                <div className="App">
                    <Router future={{
                        v7_startTransition: true,
                        v7_relativeSplatPath: true
                    }}>
                        <ScrollToTop />
                        <Navbar />
                        <Routes>
                            <Route path="/" element={<LandingPage />} />
                            <Route path="/skus/:sku" element={<SkuPage />} />
                            <Route path="/manufacturers/:stockManufacturer" element={<ManufacturerPage />} />
                            <Route path="/dates/:from/:to" element={<DatePage />} />
                            <Route path="/stocks" element={<HomePage />} />
                            <Route path="/my-tracked-stocks" element={<MyTrackedStocksPage />} />
                            <Route path="/subscription" element={<SubscriptionPage />} />
                            <Route path="/credits" element={<CreditsPage />} />
                            <Route path="/profile" element={<ProfilePage />} />
                            <Route path="/oauth2/redirect" element={<OAuth2RedirectHandler />} />
                            <Route path="/login/oauth2/code/google" element={<Navigate to="/" />} />
                            <Route path="/credits/success" element={<Navigate to="/credits?session_id=:session_id" />} />
                            <Route path="/credits/canceled" element={<Navigate to="/credits" />} />
                            <Route path="*" element={<Navigate to="/" />} />
                        </Routes>
                    </Router>
                </div>
            </ThemeProvider>
        </AuthProvider>
    );
}

export default App;